import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/credit-card',
  component: () => import('../../routes/CreditCard.svelte'),
  card: {
    id: 'credit-card',
    title: 'Credit Card Payoff',
    description: 'Optimize your payments to become debt-free faster and save on interest.',
    icon: 'credit_card',
    iconBgClass: 'bg-red-50',
    iconTextClass: 'text-red-600',
    href: '/credit-card',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Credit Card Payoff Calculator – Credit Card Debt Payoff Calculator Free',
    description: 'Free credit card payoff calculator to calculate credit card payoff time, interest costs, and required payments. The best credit card debt payoff calculator online — see how different payment strategies eliminate debt faster. Works for multiple credit card payoff planning.',
  },
};

export default meta;
